import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatRippleModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';

import { MgEmptyStateModule } from '@app/src/app/components/EmptyState';
import { MgImageModule } from '@app/src/app/components/MgImage';
import { MgIconModule } from '@app/src/app/icon';
import { PermissionsModule } from '@app/src/app/permissions';
import { MgPipesModule } from '@app/src/app/pipes';
import { FiltersFormModule } from '@app/src/app/shared/components/filters-form';
import { SystemAlertModule } from '@app/src/app/shared/components/system-alert';
import { MobileCardModule } from '@app/src/app/shared/components/tables/mobile-card/mobile-card.module';
import { SortHeaderModule } from '@app/src/app/shared/directives/sort-header/sort-header.module';
import { DayjsPipesModule } from '@app/src/app/shared/pipes/dayjs/dayjs-pipes.module';
import { MgSpinnerModule } from '@app/src/app/spinner';

import { FormModule } from '@shared/components/form';
import { GenericModule } from '@shared/components/generic';
import { ManagerOverlayModule } from '@shared/components/manager-overlay';
import { PaginatorModule } from '@shared/components/paginator';
import { TextModule } from '@shared/components/text/text.module';
import { TooltipModule } from '@shared/components/tooltip';

import { MultiPersonSearchModule } from '../../../../shared/components/multi-person-search/multi-person-search.module';
import { TeacherToolsFlexTimeService } from '../../../tools/teacher-tools/services/tt-flex-time.service';
import { FtmSharedModule } from '../ftm-shared/ftm-shared.module';
import { FtmActivitiesComponent } from './ftm-activities.component';

@NgModule({
  declarations: [FtmActivitiesComponent],
  providers: [TeacherToolsFlexTimeService],
  imports: [
    // Minga dependencies
    ManagerOverlayModule,
    MgSpinnerModule,
    FormModule,
    MgIconModule,
    MgEmptyStateModule,
    TooltipModule,
    MgImageModule,
    MgPipesModule,
    FtmSharedModule,
    TextModule,
    GenericModule,
    PaginatorModule,
    PermissionsModule,
    FiltersFormModule,
    SortHeaderModule,
    MobileCardModule,
    SystemAlertModule,
    DayjsPipesModule,

    // External dependencies
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    MatFormFieldModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatRippleModule,
    ReactiveFormsModule,
    MultiPersonSearchModule,
    MatExpansionModule,
    MatButtonToggleModule,
    MatTooltipModule,
  ],
})
export class FtmActivitiesModule {}
